"use client";

import { FC, PropsWithChildren } from "react";
import styles from "./account-bets-tabs.module.sass";

const AccountBetsTabs: FC<PropsWithChildren> = ({ children }) => {
    return <div className={styles.myBetsTabs}>{children}</div>;
};

export default AccountBetsTabs;
